import React from 'react';
import { Mail, Instagram, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-jet text-brand-cream py-16 px-4 border-t border-brand-gold/15 relative overflow-hidden" data-id="element-136">
      <div className="absolute inset-0 grain pointer-events-none" data-id="element-137"></div>

      <div className="max-w-3xl mx-auto flex flex-col items-center gap-4 relative z-10 text-center" data-id="element-138">
        <span className="text-3xl mb-1" aria-hidden data-id="element-139">
          ✦ 🌾 ✦
        </span>
        <p className="font-display text-brand-gold font-extrabold text-xl sm:text-2xl glow-gold tracking-tight" data-id="element-140">
          MEGAPACK COCINA SIN GLUTEN Y SIN AZÚCAR™
        </p>
        <p className="text-brand-cream/65 text-sm leading-relaxed max-w-xl" data-id="element-141">
          El sistema de recetas N°1 para mujeres que quieren volver a comer sin
          culpa y sin miedo a los picos de glucosa.
        </p>

        <div className="gold-divider w-2/3 my-4" data-id="element-142"></div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-sm text-brand-cream/80" data-id="element-143">
          <a href="mailto:soporte@impulsodigitalstore.com" className="flex items-center gap-2 hover:text-brand-gold transition-colors" data-id="element-144">
            <Mail size={16} className="text-brand-gold" data-id="element-145" />
            soporte@impulsodigitalstore.com
          </a>
          <span className="hidden sm:inline text-brand-gold/40" data-id="element-146">•</span>
          <a href="#" className="flex items-center gap-2 hover:text-brand-gold transition-colors" data-id="element-147">
            <Instagram size={16} className="text-brand-gold" data-id="element-148" />
            @impulsodigital.store
          </a>
          <span className="hidden sm:inline text-brand-gold/40" data-id="element-149">•</span>
          <a href="#" className="flex items-center gap-2 hover:text-brand-gold transition-colors" data-id="element-150">
            <Globe size={16} className="text-brand-gold" data-id="element-151" />
            www.impulsodigitalstore.com
          </a>
        </div>

        <div className="gold-divider w-2/3 my-4" data-id="element-152"></div>

        <div className="text-brand-cream/30 space-y-2 text-xs" data-id="element-153">
          <p data-id="element-154">
            © Impulso Digital Store™ 2026 — Todos los derechos reservados.
          </p>
          <p data-id="element-155">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <p data-id="element-156">
            Este producto es digital. No se envía ningún producto físico por
            correo.
          </p>
        </div>

        <div className="gold-divider w-2/3 my-4" data-id="element-157"></div>

        <p className="text-brand-cream/50 italic font-display text-sm sm:text-base" data-id="element-158">
          🌾 "El próximo domingo puede ser diferente."
        </p>
      </div>
    </footer>;
}